import { all, fork } from 'redux-saga/effects';

import { moderationFiltersSagas } from '../scripts/components/settings/policy/moderation-filters/moderation-filters/moderationFiltersSagas';
import { generalSettingsSagas } from '../scripts/components/preferences/general/generalSettingsSagas';

import { superAdminSagas } from './super-admin/superAdminSagas';
import { ssoSagas } from './single-sign-on/ssoSagas';

export function* settingsSagas() {
  yield all(
    [moderationFiltersSagas, generalSettingsSagas, superAdminSagas, ssoSagas].map(saga =>
      fork(saga)
    )
  );
}
